
      import Save from './save.vue'
      import type { App, Plugin } from 'vue'

      export const SavePlugin: Plugin = {
        install(app: App) {
          app.component('Save', Save)
        },
      }
      export { Save }
      